<template>
    <div class="personnel_container">
        <!-- 搜索区域 -->
        <global-tag>
            <span slot="title">验收标准</span>
            <div class="search" slot="search">
                <el-form label-width="100px">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="标题：">
                                <el-input
                                    v-model="title"
                                    placeholder="请输入标题"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="12">
                            <el-button
                                type="primary"
                                class="searchBtns"
                                @click="search"
                                >搜索</el-button
                            >
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                type="info"
                                class="resetReach"
                                @click="reset"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="el-icon-plus"
                        class="openBtns"
                        @click="handleTableForm('新增')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="Reset1"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        class="dropdown1"
                        trigger="click"
                        :hide-on-click="false"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox
                                    ><br />
                                    <el-checkbox label="标题"></el-checkbox
                                    ><br />
                                    <el-checkbox label="内容"></el-checkbox
                                    ><br />
                                    <el-checkbox label="创建人"></el-checkbox
                                    ><br />
                                    <el-checkbox label="创建时间"></el-checkbox
                                    ><br />
                                    <el-checkbox label="状态"></el-checkbox
                                    ><br />
                                    <el-checkbox label="操作"></el-checkbox>
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 页面表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    width="60px"
                    align="center"
                    label="序号"
                    type="index"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="150px"
                    align="center"
                    label="标题"
                    prop="standard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标题'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="150px"
                    align="center"
                    label="内容"
                    prop="content"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '内容'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="createPersonName"
                    min-width="60px"
                    label="创建人"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>
                <el-table-column
                    min-width="150px"
                    align="center"
                    label="创建时间"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                ></el-table-column>

                <el-table-column
                    min-width="80px"
                    align="center"
                    label="状态"
                    prop="status"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">启用</span>
                        <span v-if="scope.row.status == 1">禁用</span>
                    </template>
                </el-table-column>

                <el-table-column
                    min-width="150px"
                    align="center"
                    label="操作"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="查看"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/detail.png"
                                style="cursor: pointer"
                                @click="handleTableForm('详情', scope.row)"
                            />
                        </el-tooltip>
                        <el-tooltip
                            effect="dark"
                            content="编辑"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_edit.png"
                                @click="handleTableForm('编辑', scope.row)"
                                style="margin-left: 12px; cursor: pointer"
                            />
                        </el-tooltip>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="删除"
                            placement="top-start"
                        >
                            <img
                                src="../assets/img/table_delete.png"
                                alt=""
                                style="margin-left: 12px; cursor: pointer"
                                @click="deleteId(scope.row)"
                            />
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="pageNo"
                @size-change="handletableSize"
                @current-change="handleTableChange"
            ></el-pagination>
        </div>
        <!-- 表格表单弹窗 -->
        <el-dialog
            :title="dialogVisibleTitle"
            :visible.sync="dialogVisible"
            width="40%"
            class="dialog_container"
        >
            <div class="dialog_content">
                <el-form
                    label-position="left"
                    label-width="100px"
                    :model="formData"
                    :rules="formDataRule"
                    ref="formDataRef"
                    :disabled="dialogVisibleTitle == '详情'"
                >
                    <el-form-item label="标题：" prop="standard">
                        <el-input
                            v-model="formData.standard"
                            placeholder="请输入标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="内容：" prop="content">
                        <el-input
                            type="textarea"
                            :rows="5"
                            placeholder="请输入内容"
                            v-model="formData.content"
                        ></el-input>
                    </el-form-item>
                    <!-- 所属机构 -->
                    <el-form-item label="所属机构：">
                        <el-cascader
                            :options="orgList"
                            v-model="formData.dataId"
                            style="width: 100%"
                            v-if="dialogVisibleTitle == '新增'"
                            :props="{
                                checkStrictly: true,
                                emitPath: false,
                                label: 'label',
                                value: 'orgId',
                            }"
                        ></el-cascader>
                        <el-input
                            v-model="formData.dataName"
                            v-else
                            disabled
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-radio-group v-model="formData.status">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="附件：" prop="enclosure">
                        <el-upload
                            :action="baseUrl"
                            :show-file-list="false"
                            accept=".jpg,.png"
                            :on-success="
                                (file, fileList) => {
                                    handleAvatarSuccess(
                                        file,
                                        fileList,
                                        'proveImageUrl'
                                    )
                                }
                            "
                            :before-upload="beforeAvatarUpload"
                        >
                            <div class="avatar" v-if="imageUrl">
                                <img :src="imageUrl" />
                            </div>
                            <div v-else>
                                <div
                                    class="avatar"
                                    v-if="dialogVisibleTitle == '详情'"
                                >
                                    <img src="../assets/img/user.png" />
                                </div>
                                <i
                                    class="
                                        el-icon-plus
                                        avatar_uploader avatar-uploader-icon
                                    "
                                    v-else
                                ></i>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <span
                slot="footer"
                class="dialog-footer"
                v-if="dialogVisibleTitle != '详情'"
            >
                <el-button type="primary" :disabled="isdisabled" @click="save"
                    >确 定</el-button
                >
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import common from "../../../utils/common.js"
import globalTag from "../components/globalTag"
import baseURL from "@/api/baseURL"
export default {
    name: "standard",
    data() {
        return {
            formDataRule: {
                standard: [
                    { required: true, message: "请输入标题", trigger: "blur" },
                ],
                content: [
                    { required: true, message: "请输入内容", trigger: "blur" },
                ],
            },
            orgLevels: "",
            isdisabled: false,
            orgList: [],
            arrOrgList: [],
            total: 0,
            imageUrl: "", //图片地址
            title: "", //搜索标题
            tableData: [],
            baseUrl: "",
            formData: {
                standard: "", //标题
                content: "", //内容
                enclosure: "", //文件
                status: "0",
                dataId: "",
                dataName: "",
            },
            formDataRules: {
                title: [],
            },
            tempTableChekbox: [
                "序号",
                "标题",
                "内容",
                "创建人",
                "创建时间",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "标题",
                "内容",
                "创建人",
                "创建时间",
                "状态",
                "操作",
            ],
            total: 0,
            pageNo: 1,
            pageSize: 10,
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
        }
    },
    components: {
        globalTag,
    },
    inject: ["reload"], //注入
    methods: {
        // 获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: {
                        isValid: 1,
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (res.code == 200 && res.content) {
                        let item = this.chbehavior(
                            res.content,
                            this.$store.state.info.orgId
                        )
                        this.orgList.push(item)
                        // console.log(this.orgList)
                    }
                })
        },
        chbehavior(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        // 保留条件刷新
        Reset1() {
            this.showList()
            this.tableChekbox = [
                "序号",
                "标题",
                "内容",
                "创建时间",
                "状态",
                "操作",
            ]
        },
        // 页面刷新
        Reset() {
            this.reload()
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return isJPG
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
                return isLt2M
            }
        },
        //自定义图片上传
        handleAvatarSuccess(res, file, name) {
            this.imageUrl = res.content
            this.formData.enclosure = res.content
        },

        //处理table表格表单
        handleTableForm(title, date) {
            this.dialogVisibleTitle = title
            this.dialogVisible = true
            this.isdisabled = false
            switch (title) {
                case "新增":
                    this.formData.standard = ""
                    this.formData.content = ""
                    this.formData.status = ""
                    this.imageUrl = ""
                    break
                case "详情":
                    this.look(date)
                    break
                case "编辑":
                    this.look(date)
                    break
            }
        },
        deleteId(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/checkStandard/info/deleteById",
                    method: "POST",
                    data: params,
                }).then((res) => {
                    if ((res.code = 200)) {
                        this.showList()
                    }
                })
            })
        },
        //老人信息列表pagesize发生改变
        handletableSize(val) {
            this.pageSize = val
            this.showList()
        },
        //老人信息列表页码发生改变
        handleTableChange(val) {
            this.pageNo = val
            this.showList()
        },
        async showList() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/checkStandard/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.tableData = res.content.list
                    this.total = res.content.count
                    if (res.content == null || res.content == "null") {
                        this.tableData = []
                        this.total = 0
                    }
                }
            })
        },
        async search() {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                standard: this.title,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/checkStandard/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                if (res.content != null) {
                    this.tableData = res.content.list
                    this.total = res.content.count
                } else {
                    this.tableData = []
                    this.total = 0
                }
            })
        },
        async save() {
            if (this.formData.standard === "") {
                this.$message.error("标题不能为空")
                return
            }
            if (this.formData.content === "") {
                this.$message.error("内容不能为空")
                return
            }
            // console.log(this.formData)
            let params = {
                ...this.formData,
            }
            params = Object.assign({}, params)
            this.isdisabled = true
            await request({
                url: "/jjyl/admin/checkStandard/info/insertOrUpdate",
                method: "POST",
                data: params,
            }).then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.dialogVisible = false
                    this.formData = {}
                    this.showList()
                }
            })
        },
        look(date) {
            let params = {
                id: date.id,
            }
            params = Object.assign({}, params)
            let that = this
            request({
                url: "/jjyl/admin/checkStandard/info/getById",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    console.log(that.orgList)
                    that.formData = res.content
                    that.imageUrl = res.content.enclosure
                    that.formData.dataName = that.getdataName(
                        that.orgList,
                        res.content.dataId
                    )
                    console.log(that.formData.dataName)
                }
            })
        },
        getdataName(arr, id) {
            let res
            ;(function deepId(arr, id) {
                for (let a of arr) {
                    if (a.orgId == id) {
                        res = a.label
                    } else if (a.children && !res) {
                        deepId(a.children, id)
                    }
                }
            })(arr, id)
            return res
        },
        reset() {
            this.pageNo = 1
            this.pageSize = 10
            this.title = ""
            this.showList()
        },
    },
    created() {
        this.baseUrl =
            baseURL + "/jjyl/controller/uploadController/info/uploadPhoto"
        this.showList()
        this.getOrg()
    },
}
</script>

<style lang="less" scoped>
.table_container {
    width: 100%;
}
.avatar_uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    img {
        width: 100%;
        height: 100%;
        display: block;
    }
}
/deep/ .dialog_content {
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
}
</style>